// extracted by mini-css-extract-plugin
export var chevronIcon = "_3z-2";
export var teamName = "_3z-1";
export var teamSwitcherButton = "_3z-0";